// Progressive enhancement for server-rendered sliders: Fusion renders
// .swiper > .swiper-wrapper > .swiper-slide markup plus a slick-named config
// JSON in data-swiper-config; this module maps it to Swiper options.
// No Vue here on purpose - mounting Vue would replace the server-rendered
// slides and destroy the Neos backend metadata on them.
import Swiper from 'swiper'
import { Navigation, Pagination, Autoplay, EffectFade, A11y } from 'swiper/modules'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'
import 'swiper/css/effect-fade'

// xxl (1600) ergänzt die Tailwind-Stufen: die Referenz-Karussells zeigen ab
// 1600px sechs Bilder (live owl-Breakpoint 1600).
const BREAKPOINTS = { sm: 640, md: 768, lg: 1024, xl: 1280, xxl: 1600 }

function slickToSwiperOptions(cfg, el) {
	const options = {
		modules: [Navigation, Pagination, Autoplay, EffectFade, A11y],
		slidesPerView: cfg.slidesToShow || 1,
		slidesPerGroup: cfg.slidesToScroll || 1,
		loop: cfg.infinite !== false,
		speed: typeof cfg.speed === 'number' ? cfg.speed : 500,
		allowTouchMove: cfg.draggable !== false,
	}

	if (typeof cfg.spaceBetween === 'number') {
		options.spaceBetween = cfg.spaceBetween
	}

	if (cfg.fade) {
		options.effect = 'fade'
		options.fadeEffect = { crossFade: true }
		options.slidesPerView = 1
		options.slidesPerGroup = 1
	}

	if (cfg.autoplay) {
		options.autoplay = {
			delay: typeof cfg.autoplaySpeed === 'number' ? cfg.autoplaySpeed : 3000,
			pauseOnMouseEnter: cfg.pauseOnHover !== false,
		}
	}

	if (cfg.arrows !== false) {
		// Pfeile sind Kinder des .swiper — oder (Referenz-Karussells, die über
		// den Rand hinausragen) Geschwister im umgebenden Wrapper, weil .swiper
		// per overflow:hidden alles außerhalb abschneidet.
		const nav = (cls) =>
			el.querySelector(':scope > ' + cls) ||
			(el.parentElement && el.parentElement.querySelector(':scope > ' + cls))
		options.navigation = {
			prevEl: nav('.swiper-button-prev'),
			nextEl: nav('.swiper-button-next'),
		}
	}

	if (cfg.dots) {
		options.pagination = {
			el: el.querySelector(':scope > .swiper-pagination'),
			clickable: true,
		}
	}

	const breakpoints = {}
	for (const key of Object.keys(BREAKPOINTS)) {
		const bp = cfg.responsive && cfg.responsive[key]
		if (bp) {
			breakpoints[BREAKPOINTS[key]] = {
				slidesPerView: bp.slidesToShow || 1,
				slidesPerGroup: bp.slidesToScroll || 1,
			}
			if (typeof bp.spaceBetween === 'number') {
				breakpoints[BREAKPOINTS[key]].spaceBetween = bp.spaceBetween
			}
		}
	}
	if (Object.keys(breakpoints).length) {
		options.breakpoints = breakpoints
	}

	// In the Neos backend the slider must not move under the editor
	if (cfg.isBackend) {
		options.autoplay = false
		options.loop = false
		options.allowTouchMove = false
	}

	return options
}

export function initSwiperSliders(root = document) {
	root.querySelectorAll('[data-swiper]').forEach((el) => {
		if (el._swiperInstance) return
		let cfg = {}
		try {
			cfg = JSON.parse(el.dataset.swiperConfig || '{}')
		} catch (e) {
			console.warn('Invalid data-swiper-config JSON', el, e)
		}
		el._swiperInstance = new Swiper(el, slickToSwiperOptions(cfg, el))
	})
}
